export type API = 'admin' | 'storefront-renderer' | 'partners'

export const allAPIs: API[] = ['admin', 'storefront-renderer', 'partners']
